import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import all translation files
import enCommon from './locales/en/common.json';
import enNavigation from './locales/en/navigation.json';
import enLanguages from './locales/en/languages.json';
import enFooter from './locales/en/footer.json';
import enPatagonia from './locales/en/properties/patagonia.json';
import enAtacama from './locales/en/properties/atacama.json';
import enIguazu from './locales/en/properties/iguazu.json';
import enMendoza from './locales/en/properties/mendoza.json';
import enSantaCatarina from './locales/en/properties/santa-catarina.json';
// Page translations
import enHome from './locales/en/pages/home.json';
import enPackages from './locales/en/pages/packages.json';
import enOurStory from './locales/en/pages/ourStory.json';
import enDestinations from './locales/en/pages/destinations.json';
import enFilmCollection from './locales/en/pages/filmCollection.json';
import enProducingNature from './locales/en/pages/producingNature.json';
import enBlog from './locales/en/pages/blog.json';
import enArtImmersions from './locales/en/pages/artImmersions.json';
import enReEnergize from './locales/en/pages/reEnergize.json';
import enAboutUs from './locales/en/pages/aboutUs.json';
import enPressAwards from './locales/en/pages/pressAwards.json';

import esCommon from './locales/es/common.json';
import esNavigation from './locales/es/navigation.json';
import esLanguages from './locales/es/languages.json';
import esFooter from './locales/es/footer.json';
import esPatagonia from './locales/es/properties/patagonia.json';
import esAtacama from './locales/es/properties/atacama.json';
import esIguazu from './locales/es/properties/iguazu.json';
import esMendoza from './locales/es/properties/mendoza.json';
import esSantaCatarina from './locales/es/properties/santa-catarina.json';
// Page translations
import esHome from './locales/es/pages/home.json';
import esPackages from './locales/es/pages/packages.json';
import esOurStory from './locales/es/pages/ourStory.json';
import esDestinations from './locales/es/pages/destinations.json';
import esFilmCollection from './locales/es/pages/filmCollection.json';
import esProducingNature from './locales/es/pages/producingNature.json';
import esBlog from './locales/es/pages/blog.json';
import esArtImmersions from './locales/es/pages/artImmersions.json';
import esReEnergize from './locales/es/pages/reEnergize.json';
import esAboutUs from './locales/es/pages/aboutUs.json';
import esPressAwards from './locales/es/pages/pressAwards.json';

import ptCommon from './locales/pt/common.json';
import ptNavigation from './locales/pt/navigation.json';
import ptLanguages from './locales/pt/languages.json';
import ptFooter from './locales/pt/footer.json';
import ptPatagonia from './locales/pt/properties/patagonia.json';
import ptAtacama from './locales/pt/properties/atacama.json';
import ptIguazu from './locales/pt/properties/iguazu.json';
import ptMendoza from './locales/pt/properties/mendoza.json';
import ptSantaCatarina from './locales/pt/properties/santa-catarina.json';
// Page translations
import ptHome from './locales/pt/pages/home.json';
import ptPackages from './locales/pt/pages/packages.json';
import ptOurStory from './locales/pt/pages/ourStory.json';
import ptDestinations from './locales/pt/pages/destinations.json';
import ptFilmCollection from './locales/pt/pages/filmCollection.json';
import ptProducingNature from './locales/pt/pages/producingNature.json';
import ptBlog from './locales/pt/pages/blog.json';
import ptArtImmersions from './locales/pt/pages/artImmersions.json';
import ptReEnergize from './locales/pt/pages/reEnergize.json';
import ptAboutUs from './locales/pt/pages/aboutUs.json';
import ptPressAwards from './locales/pt/pages/pressAwards.json';

import deCommon from './locales/de/common.json';
import deNavigation from './locales/de/navigation.json';
import deLanguages from './locales/de/languages.json';
import deFooter from './locales/de/footer.json';
import dePatagonia from './locales/de/properties/patagonia.json';
import deAtacama from './locales/de/properties/atacama.json';
import deIguazu from './locales/de/properties/iguazu.json';
import deMendoza from './locales/de/properties/mendoza.json';
import deSantaCatarina from './locales/de/properties/santa-catarina.json';
// Page translations
import deHome from './locales/de/pages/home.json';
import dePackages from './locales/de/pages/packages.json';
import deOurStory from './locales/de/pages/ourStory.json';
import deDestinations from './locales/de/pages/destinations.json';
import deFilmCollection from './locales/de/pages/filmCollection.json';
import deProducingNature from './locales/de/pages/producingNature.json';
import deBlog from './locales/de/pages/blog.json';
import deArtImmersions from './locales/de/pages/artImmersions.json';
import deReEnergize from './locales/de/pages/reEnergize.json';
import deAboutUs from './locales/de/pages/aboutUs.json';
import dePressAwards from './locales/de/pages/pressAwards.json';

import frCommon from './locales/fr/common.json';
import frNavigation from './locales/fr/navigation.json';
import frLanguages from './locales/fr/languages.json';
import frFooter from './locales/fr/footer.json';
import frPatagonia from './locales/fr/properties/patagonia.json';
import frAtacama from './locales/fr/properties/atacama.json';
import frIguazu from './locales/fr/properties/iguazu.json';
import frMendoza from './locales/fr/properties/mendoza.json';
import frSantaCatarina from './locales/fr/properties/santa-catarina.json';
// Page translations
import frHome from './locales/fr/pages/home.json';
import frPackages from './locales/fr/pages/packages.json';
import frOurStory from './locales/fr/pages/ourStory.json';
import frDestinations from './locales/fr/pages/destinations.json';
import frFilmCollection from './locales/fr/pages/filmCollection.json';
import frProducingNature from './locales/fr/pages/producingNature.json';
import frBlog from './locales/fr/pages/blog.json';
import frArtImmersions from './locales/fr/pages/artImmersions.json';
import frReEnergize from './locales/fr/pages/reEnergize.json';
import frAboutUs from './locales/fr/pages/aboutUs.json';
import frPressAwards from './locales/fr/pages/pressAwards.json';

// Supported languages
export const SUPPORTED_LANGUAGES = ['de', 'fr', 'pt', 'es', 'en'] as const;
export type SupportedLanguage = typeof SUPPORTED_LANGUAGES[number];

// Default language
export const DEFAULT_LANGUAGE: SupportedLanguage = 'en';

// Language names for display
export const LANGUAGE_NAMES: Record<SupportedLanguage, string> = {
  de: 'Deutsch',
  fr: 'Français',
  pt: 'Português',
  es: 'Español',
  en: 'English'
};

// Initialize i18n
const resources = {
  en: {
    common: enCommon,
    navigation: enNavigation,
    languages: enLanguages,
    footer: enFooter,
    'properties/patagonia': enPatagonia,
    'properties/atacama': enAtacama,
    'properties/iguazu': enIguazu,
    'properties/mendoza': enMendoza,
    'properties/santa-catarina': enSantaCatarina,
    // Pages
    'pages/home': enHome,
    'pages/packages': enPackages,
    'pages/ourStory': enOurStory,
    'pages/destinations': enDestinations,
    'pages/filmCollection': enFilmCollection,
    'pages/producingNature': enProducingNature,
    'pages/blog': enBlog,
    'pages/artImmersions': enArtImmersions,
    'pages/reEnergize': enReEnergize,
    'pages/aboutUs': enAboutUs,
    'pages/pressAwards': enPressAwards
  },
  es: {
    common: esCommon,
    navigation: esNavigation,
    languages: esLanguages,
    footer: esFooter,
    'properties/patagonia': esPatagonia,
    'properties/atacama': esAtacama,
    'properties/iguazu': esIguazu,
    'properties/mendoza': esMendoza,
    'properties/santa-catarina': esSantaCatarina,
    // Pages
    'pages/home': esHome,
    'pages/packages': esPackages,
    'pages/ourStory': esOurStory,
    'pages/destinations': esDestinations,
    'pages/filmCollection': esFilmCollection,
    'pages/producingNature': esProducingNature,
    'pages/blog': esBlog,
    'pages/artImmersions': esArtImmersions,
    'pages/reEnergize': esReEnergize,
    'pages/aboutUs': esAboutUs,
    'pages/pressAwards': esPressAwards
  },
  pt: {
    common: ptCommon,
    navigation: ptNavigation,
    languages: ptLanguages,
    footer: ptFooter,
    'properties/patagonia': ptPatagonia,
    'properties/atacama': ptAtacama,
    'properties/iguazu': ptIguazu,
    'properties/mendoza': ptMendoza,
    'properties/santa-catarina': ptSantaCatarina,
    // Pages
    'pages/home': ptHome,
    'pages/packages': ptPackages,
    'pages/ourStory': ptOurStory,
    'pages/destinations': ptDestinations,
    'pages/filmCollection': ptFilmCollection,
    'pages/producingNature': ptProducingNature,
    'pages/blog': ptBlog,
    'pages/artImmersions': ptArtImmersions,
    'pages/reEnergize': ptReEnergize,
    'pages/aboutUs': ptAboutUs,
    'pages/pressAwards': ptPressAwards
  },
  de: {
    common: deCommon,
    navigation: deNavigation,
    languages: deLanguages,
    footer: deFooter,
    'properties/patagonia': dePatagonia,
    'properties/atacama': deAtacama,
    'properties/iguazu': deIguazu,
    'properties/mendoza': deMendoza,
    'properties/santa-catarina': deSantaCatarina,
    // Pages
    'pages/home': deHome,
    'pages/packages': dePackages,
    'pages/ourStory': deOurStory,
    'pages/destinations': deDestinations,
    'pages/filmCollection': deFilmCollection,
    'pages/producingNature': deProducingNature,
    'pages/blog': deBlog,
    'pages/artImmersions': deArtImmersions,
    'pages/reEnergize': deReEnergize,
    'pages/aboutUs': deAboutUs,
    'pages/pressAwards': dePressAwards
  },
  fr: {
    common: frCommon,
    navigation: frNavigation,
    languages: frLanguages,
    footer: frFooter,
    'properties/patagonia': frPatagonia,
    'properties/atacama': frAtacama,
    'properties/iguazu': frIguazu,
    'properties/mendoza': frMendoza,
    'properties/santa-catarina': frSantaCatarina,
    // Pages
    'pages/home': frHome,
    'pages/packages': frPackages,
    'pages/ourStory': frOurStory,
    'pages/destinations': frDestinations,
    'pages/filmCollection': frFilmCollection,
    'pages/producingNature': frProducingNature,
    'pages/blog': frBlog,
    'pages/artImmersions': frArtImmersions,
    'pages/reEnergize': frReEnergize,
    'pages/aboutUs': frAboutUs,
    'pages/pressAwards': frPressAwards
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: DEFAULT_LANGUAGE,
    defaultNS: 'common',
    ns: [
      'common', 
      'navigation', 
      'languages', 
      'footer', 
      'properties/patagonia', 
      'properties/atacama', 
      'properties/iguazu', 
      'properties/mendoza', 
      'properties/santa-catarina',
      'pages/home',
      'pages/packages',
      'pages/ourStory',
      'pages/destinations',
      'pages/filmCollection',
      'pages/producingNature',
      'pages/blog',
      'pages/artImmersions',
      'pages/reEnergize',
      'pages/aboutUs',
      'pages/pressAwards'
    ],
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'awasi-language',
      lookupFromPathIndex: 0
    },
    
    interpolation: {
      escapeValue: false // React already escapes values
    },
    
    react: {
      useSuspense: false // Disable suspense for better control
    },
    
    debug: process.env.NODE_ENV === 'development'
  });

export default i18n;